import Accounts from "../appPages/Accounts.vue";
import AutenticMarket from "../pages/AutenticMarket.vue";
import AUtSales from "@/appPages/AUtSales.vue";

import BlockDex from "@/appPages/BlockDex.vue";
import BuyForm from "@/appPages/BuyForm.vue";
import CardBuyForm from "@/appPages/CardBuyForm.vue";
import CardWithdrawForm from "@/appPages/CardWithdrawForm.vue";
import TradeHistory from "@/appPages/TradeHistory.vue";

import AuthSocial from "../pages/AuthSocial.vue";
import Business from "../appPages/Business.vue";
import BuyAut from "@/appPages/BuyAut.vue";
import CapitalHistory from "@/appPages/CapitalHistory.vue";
import CoinInfo from "@/appPages/CoinInfo.vue";
import Companies from "../appPages/Companies.vue";
import CompanyManager from "@/components/CompanyManager.vue";
import ConvertToken from "@/appPages/ConvertToken.vue";
import Counterparties from "../appPages/Counterparties.vue";
import CounterpartyForm from "@/components/counterpartyForm/CounterpartyForm.vue";
import DAOEvents from "@/appPages/DAOEvents.vue";
import DaoForm from "@/components/DaoForm.vue";
import DAORequests from "@/appPages/DAORequests.vue";
import DaoTokens from "../appPages/DaoTokens.vue";
import Dashboard from "../appPages/Dashboard.vue";
import DashboardEmitent from "@/appPages/DashboardEmitent.vue";
import Dividends from "../appPages/Dividends.vue";
import DividendsHistory from "@/appPages/DividendsHistory.vue";
import DividendsIssuer from "@/appPages/DividendsIssuer.vue";
import DividendsPay from "@/appPages/DividendsPay.vue";
import Documentation from "@/appPages/Documentation.vue";
import EditPortfolioTracker from "@/appPages/ProjectEditPortfolioTracker.vue";
import EmailVerify from "@/pages/EmailVerify.vue";
import Faq from "@/pages/Faq.vue";
import GoodForm from "@/appPages/GoodForm.vue";
import Investers from "../appPages/Investers.vue";
import InvestGoods from "@/appPages/InvestGoods.vue";
import KYCPage from "@/appPages/KYCPage.vue";
import Login from "../pages/Login.vue";
import Logout from "../pages/Logout.vue";
import Marketplace from "@/appPages/Marketplace.vue";
import MarketplaceCard from "@/appPages/MarketplaceCard.vue";
import MyAssets from "../appPages/MyAssets.vue";
import MyGoods from "@/appPages/MyGoods.vue";
import MyPlatforms from "@/appPages/MyPlatforms.vue";
import MyProjects from "@/appPages/MyProjects.vue";
import NewPlatform from "@/appPages/NewPlatform.vue";
import News from "../appPages/News.vue";
import NewsForm from "../appPages/NewsForm.vue";
import NewsList from "../appPages/NewsList.vue";
import OuterProjects from "@/appPages/OuterProjects.vue";
import PageNotFound from "@/pages/PageNotFound.vue";
import PaymentMethod from "../pages/PaymentMethod.vue";
import Pays from "@/appPages/Pays.vue";
import PortfolioExplorer from "@/appPages/PortfolioExplorer.vue";
import PrivacyPolicy from "@/pages/PrivacyPolicy.vue";
import ProjectCard from "@/appPages/ProjectCard.vue";
import ProjectEscrowWithdrawal from "@/appPages/ProjectEscrowWithdrawal";
import ProjectForm from "@/appPages/ProjectForm.vue";
import ProjectInvestors from "@/appPages/ProjectInvestors.vue";
import ProjectPage from "@/components/uikit/platformPages/ProjectPage.vue";
import ProjectPortfolioTracker from "@/appPages/ProjectPortfolioTracker.vue";
import Projects from "@/appPages/Projects.vue";
import ReferralProgram from "../pages/ReferralProgram.vue";
import Referrals from "@/appPages/Referrals.vue";
import Reports from "../appPages/Reports.vue";
import Requisites from "@/appPages/Requisites";
import Security from "../pages/Security.vue";
import SendToken from "../appPages/SendToken.vue";
import Settings from "../pages/Settings.vue";
import SingleNews from "@/appPages/SingleNews.vue";
import StockDeposit from "@/appPages/StockDeposit.vue";
import StockWithdraw from "@/appPages/StockWithdraw.vue";
import Support from "../pages/Support.vue";
import Swagger from "@/appPages/Swagger.vue";
import TermsOfUse from "@/pages/TermsOfUse.vue";
import TestEnv from "../pages/TestEnv.vue";
import TestPage from "../appPages/TestPage.vue";
import TokenInfo from "@/appPages/TokenInfo.vue";
import TonKeeper from "../appPages/TonKeeper.vue";
import TonWalletVerification from "../appPages/TonWalletVerification.vue";
import Transactions from "../appPages/Transactions.vue";
import User from "../pages/User.vue";
import UserAgreement from "@/pages/UserAgreement.vue";
import VoitingProtocol from "@/appPages/VoitingProtocol.vue";
import Wallet from "../pages/Wallet.vue";
import WalletVerification from "../appPages/WalletVerification.vue";

import Unsubscribe from "../appPages/Unsubscribe.vue";

import InvestProjects from "@/appPages/InvestProjects.vue";
import InvestProjectsApplication from "@/appPages/InvestProjectsApplication.vue";

import MultitokenCard from "@/appPages/MultitokenCard.vue";
import NewsCapital from "@/appPages/NewsCapital.vue";

import BlockScan from "@/appPages/BlockScan.vue";
import PasswordRestore from "@/appPages/PasswordRestore.vue";
import Withdraw from "@/appPages/Withdraw.vue";

import OAuth from "@/pages/OAuth.vue";

import Base from "@/pages/Base.vue";

import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "",
    name: "base",
    component: Base
  },
  {
    path: "/oauth",
    name: "oauth",
    component: OAuth,
    meta: {
      outer: true
    }
  },
  {
    path: "/outer-projects",
    name: "outer projects",
    component: OuterProjects,
    meta: {
      title: "router.pages.projects",
      outer: true
    }
  },
  {
    path: "/outer-project/:id",
    name: "outer project",
    component: ProjectCard,
    meta: {
      title: "router.pages.projectsEdit",
      outer: true
    }
  },
  {
    path: "/unsubscribe/:secret",
    name: "unsubscribe",
    component: Unsubscribe,
    meta: {
      title: "router.wallet",
      logo: "logo",
      isMain: true,
      auth: true
    }
  },
  {
    path: "/testpage",
    component: TestPage,
    name: "TestPage",
    props: true,
    meta: {
      title: "Test page",
      icon: "swap_vertical_green",
      access: ["user", "manager", "issuer"]
    }
  },
  {
    path: "/faq",
    component: Faq,
    name: "faq",
    props: true,
    meta: {
      title: "FAQ",
      outer: true
    }
  },
  {
    path: "/",
    name: "wallet",
    component: Wallet,
    meta: {
      title: "router.assets",
      logo: "logo",
      isMain: true,
      auth: true
    },
    children: [
      {
        path: "",
        name: "wallet empty",
        redirect: "/dashboard"
      },
      {
        path: "/dashboard",
        name: "dashboard",
        component: Dashboard,
        meta: {
          title: "router.pages.dashboard",
          icon: "grid_round_green",
          access: ["user", "manager"],
          adaptiveRightPanel: true,
          hideMyAsset: true
        }
      },
      {
        path: "issuer",
        name: "issuer",
        component: DashboardEmitent,
        meta: {
          title: "router.pages.dashboard",
          icon: "grid_round_green",
          access: ["issuer"],
          parent: "dashboard",
          adaptiveRightPanel: true
        }
      },
      {
        path: "dividends-issuer/:id?",
        name: "dividends issuer",
        props: true,
        component: DividendsIssuer,
        meta: {
          title: "router.pages.dividends"
        }
      },
      {
        path: "dividends-history/:id?",
        name: "dividends history",
        props: true,
        component: DividendsHistory,
        meta: {
          title: "router.pages.dividendsHistory"
        }
      },
      {
        path: "requisites",
        component: Requisites,
        name: "requisites",
        meta: {
          title: "router.pages.requisites",
          icon: "activity_green",
          access: ["issuer"]
        }
      },
      {
        path: "my-goods",
        name: "my goods",
        component: MyGoods,
        meta: {
          title: "router.pages.goods",
          icon: "goods",
          access: ["issuer"]
        }
      },
      {
        path: "my-projects",
        name: "my projects",
        component: MyProjects,
        meta: {
          title: "router.pages.projects",
          icon: "folder",
          access: ["issuer"]
        },
        children: [
          {
            path: "edit-project/:id",
            component: ProjectForm,
            name: "edit project",
            props: true,
            meta: {
              title: "router.pages.projectsEdit",
              noColumnReverse: true
            }
          },
          {
            path: "edit-project2/:id",
            component: ProjectFormV2,
            name: "edit project v2",
            props: true,
            meta: {
              title: "router.pages.projectsEdit",
              noColumnReverse: true
            }
          }
        ]
      },
      {
        path: "companies",
        name: "companies",
        component: Companies,
        meta: {
          title: "router.pages.companies",
          isHelp: true,
          icon: "company",
          access: ["issuer"]
        },
        children: [
          {
            path: "company-manager/:id?",
            component: CompanyManager,
            name: "company manager",
            props: true,
            meta: {
              title: "router.pages.companyManager"
            }
          }
        ]
      },
      {
        //TODO: Это скорее всего роут 3 уровня
        path: "dao-tokens/:id?",
        name: "dao tokens",
        component: DaoTokens,
        props: true,
        meta: {
          title: "router.pages.daoTokens",
          isHelp: true
          //access: ["user", "manager"]
        }
      },
      {
        path: "my-assets",
        component: MyAssets,
        name: "my assets",
        meta: {
          keepAlive: true,
          title: "router.pages.briefcase",
          icon: "bag_green",
          access: ["user", "manager"]
        },
        children: [
          {
            path: "buy-form",
            name: "buy form",
            component: BuyForm,
            meta: {
              title: "router.pages.topUp"
            }
          },
          {
            path: "card-buy-form",
            component: CardBuyForm,
            name: "card buy form",
            props: true,
            meta: {
              title: "router.pages.topUp"
            }
          },
          {
            path: "card-withdraw-form",
            component: CardWithdrawForm,
            name: "card withdraw form",
            props: true,
            meta: {
              title: "router.pages.withdraw"
            }
          },
          {
            path: "withdraw",
            name: "withdraw",
            component: Withdraw,
            meta: {
              title: "router.pages.withdraw"
            }
          },
          {
            path: "convert-token",
            component: ConvertToken,
            name: "convert token",
            meta: {
              title: "router.pages.convertToken"
            }
          },
          {
            path: "stock-deposit/:id",
            component: StockDeposit,
            name: "stock deposit",
            props: true,
            meta: {
              title: "router.pages.stockDeposit"
            }
          },
          {
            path: "stock-withdraw/:id",
            component: StockWithdraw,
            name: "stock withdraw",
            props: true,
            meta: {
              title: "router.pages.stockWithdraw"
            }
          }
        ]
      },
      {
        path: "send-token/:id",
        component: SendToken,
        name: "send token",
        props: true,
        meta: {
          title: "router.pages.sendToken",
          checkAccess: () => checkAccess(scope.notRwa),
          noColumnReverse: true
        }
      },
      {
        path: "tonkeeper",
        component: TonKeeper,
        name: "TonKeeper",
        props: true,
        meta: {
          title: "TonKeeper",
          icon: "swap_vertical_green"
          // access: ["user", "manager", "issuer"]
        }
      },
      {
        path: "token-info/:id?",
        component: TokenInfo,
        name: "token info",
        props: true,
        meta: {
          title: "router.pages.transactions"
        }
      },
      {
        path: "coin-info/:id?",
        component: CoinInfo,
        name: "coin info",
        props: true,
        meta: {
          title: "router.pages.transactions"
        }
      },
      {
        path: "my-accounts",
        name: "my accounts",
        meta: {
          title: "router.pages.accounts",
          icon: "activity_green",
          access: ["manager"]
        }
      },
      {
        path: "invest-goods",
        name: "invest goods",
        component: InvestGoods,
        meta: {
          title: "router.pages.project",
          icon: "goods",
          access: ["user", "manager", "issuer"]
        }
      },
      {
        path: "transactions",
        component: Transactions,
        name: "transactions",
        meta: {
          title: "router.pages.transactions",
          icon: "swap_vertical_green",
          access: ["user", "manager", "issuer"]
        }
      },
      {
        path: "blockscan",
        component: BlockScan,
        name: "blockscan",
        meta: {
          title: "router.pages.blockScan",
          icon: "blockscan",
          access: ["user", "manager", "issuer"]
        }
      },
      {
        path: "buyAut",
        component: BuyAut,
        name: "buyAut",
        meta: {
          title: "router.pages.blockScan",
          icon: "blockscan",
          access: ["user", "manager", "issuer"]
        }
      },
      {
        path: "dividends",
        component: Dividends,
        name: "dividends",
        meta: {
          title: "router.pages.dividends",
          icon: "graph_green"
          //access: ["user"]
        }
      },
      {
        path: "counterparties",
        component: Counterparties,
        name: "counterparties",
        meta: {
          title: "router.pages.counterparties",
          icon: "users_green",
          access: ["manager", "issuer"]
        },
        children: [
          {
            path: "edit-counterparty/:id",
            component: CounterpartyForm,
            name: "edit counterparty",
            props: true,
            meta: {
              title: "router.pages.editCounterparty",
              noColumnReverse: true
            }
          }
        ]
      },
      {
        path: "reports",
        component: Reports,
        name: "reports",
        meta: {
          title: "router.pages.reports",
          icon: "chat_green"
          //access: ["user", "manager", "issuer"]
        }
      },
      {
        path: "invest-projects",
        component: InvestProjects,
        name: "invest projects",
        meta: {
          title: "router.pages.investProjects"
          //access: ["user"]
        }
      },
      {
        path: "invest-projects-application",
        component: InvestProjectsApplication,
        name: "invest projects application",
        meta: {
          title: "router.pages.investProjectsApplication"
        }
      },
      {
        path: "accounts",
        component: Accounts,
        name: "accounts",
        meta: {
          title: "router.pages.account"
        }
      },
      // {
      //   path: "accounts",
      //   component: Accounts,
      //   name: "accounts",
      //   meta: {
      //     title: "router.pages.account"
      //   }
      // },
      {
        path: "news",
        component: News,
        name: "news",
        meta: {
          title: "router.pages.news",
          icon: "news_glasses"
        },
        children: [
          {
            path: "edit-news/:id",
            component: NewsForm,
            name: "edit news",
            props: true,
            meta: {
              title: "router.pages.editNews",
              noColumnReverse: true
            }
          }
        ]
      },
      // {
      //   path: "news/:id",
      //   component: SingleNews,
      //   name: "single news",
      //   props: true,
      //   meta: {
      //     title: "router.pages.newsOne",
      //     noColumnReverse: true,
      //     hideNews: true
      //   }
      // },
      {
        path: "all-news",
        component: NewsList,
        name: "all news",
        props: true,
        meta: {
          title: "router.pages.news",
          noColumnReverse: true,
          hideNews: true
        }
      },
      {
        path: "user",
        name: "user",
        component: User,
        meta: {
          title: "router.pages.user"
        }
      },
      {
        path: "testenv",
        name: "TestEnv",
        component: TestEnv,
        meta: {
          title: "TestEnv"
        }
      },
      {
        path: "referral-program",
        name: "referral program",
        component: ReferralProgram,
        meta: {
          title: "router.pages.referralProgram"
        }
      },
      {
        path: "payment-method",
        name: "payment method",
        component: PaymentMethod,
        meta: {
          title: "router.pages.paymentMethod"
        }
      },
      {
        path: "security",
        name: "security",
        component: Security,
        meta: {
          title: "router.pages.security"
        }
      },
      {
        path: "wallet-verification",
        name: "walletVerification",
        component: WalletVerification,
        meta: {
          title: "router.pages.walletVerification",
          checkAccess: () => checkAccess(scope.notRwa)
        }
      },
      {
        path: "ton-wallet-verification",
        name: "tonWalletVerification",
        component: TonWalletVerification,
        meta: {
          title: "router.pages.tonWalletVerification",
          checkAccess: () => checkAccess(scope.notRwa)
        }
      },
      {
        path: "settings",
        name: "settings",
        component: Settings,
        meta: {
          title: "router.pages.settings"
        }
      },
      {
        path: "support",
        name: "support",
        component: Support,
        meta: {
          title: "router.pages.support"
        }
      },
      {
        path: "my-goods/edit-good/:id",
        name: "edit good",
        component: GoodForm,
        meta: {
          title: "router.pages.editGood"
        }
      },
      // {
      //   path: "assets-invest",
      //   name: "assets invest",
      //   component: AssetsInvest,
      //   meta: {
      //     title: "router.pages.assetsInvest"
      //   }
      // },
      {
        path: "autsales",
        name: "AUtSales",
        component: AUtSales,
        meta: {
          title: "router.pages.autSales",
          access: ["debug"]
        }
      },
      {
        path: "pays/:hash?",
        name: "pays",
        props: true,
        component: Pays,
        meta: {
          title: "router.pages.pays"
        }
      },
      {
        path: "dao-requests/:id?",
        name: "dao requests",
        props: true,
        component: DAORequests,
        meta: {
          title: "router.pages.daoRequests"
        }
      },
      {
        path: "dao-form",
        name: "dao form",
        props: {},
        component: DaoForm
      },
      {
        path: "dao-events/:id?",
        name: "dao events",
        props: true,
        component: DAOEvents,
        meta: {
          title: "router.pages.daoEvents"
        }
      },
      {
        path: "documentation",
        name: "documentation",
        component: Documentation,
        meta: {
          title: "router.pages.documentation"
        }
      },
      {
        path: "project-investors/:id?",
        name: "project investors",
        props: true,
        component: ProjectInvestors,
        meta: {
          title: "router.pages.projectInvestors"
        }
      },
      {
        path: "portfolio-tracker/:id?",
        name: "portfolio tracker",
        props: true,
        component: ProjectPortfolioTracker,
        meta: {
          title: "router.pages.projectPortfolioTracker"
        }
      },
      {
        path: "escrow-withdrawal/:id?",
        name: "escrow withdrawal",
        props: true,
        component: ProjectEscrowWithdrawal,
        meta: {
          title: "router.pages.projectEscrowWithdrawal"
        }
      },
      {
        path: "edit-portfolio/:id?",
        component: EditPortfolioTracker,
        name: "edit portfolio",
        props: true,
        meta: {
          title: "router.pages.projectPortfolioTracker",
          noColumnReverse: true
        }
      },
      {
        path: "blockdex",
        name: "blockdex",
        component: BlockDex,
        meta: {
          title: "router.pages.buyCryptoAssets",
          showMenu: false
        }
      },
      {
        path: "trade-history",
        name: "trade history",
        component: TradeHistory,
        meta: {
          title: "router.pages.conversionStory",
          showMenu: false
        }
      },
      {
        path: "voiting-protocol/:id?",
        name: "voiting protocol",
        props: true,
        component: VoitingProtocol,
        meta: {
          title: "router.pages.protocolVoting",
          showMenu: false
        }
      },
      {
        path: "dividends-pay/:id?",
        name: "dividends pay",
        props: true,
        component: DividendsPay,
        meta: {
          title: "router.pages.dividendPay",
          showMenu: false
        }
      },
      {
        path: "/kyc",
        name: "kyc",
        component: KYCPage,
        meta: {
          title: "router.pages.kyc"
        }
      },
      {
        path: "",
        name: "autentic capital empty",
        redirect: "/projects"
      },
      {
        path: "it-parks",
        name: "it parks",
        props: true,
        component: ItParkListPage
      },
      {
        path: "it-park-edit/:id?",
        name: "it park edit",
        props: true,
        component: ItParkEditPage
      },
      {
        path: "it-park/:id?",
        name: "it park",
        props: true,
        component: ItParkShowPage
      },
      {
        path: "project-voters/:id?",
        name: "project voters",
        props: true,
        component: ProjectVotersPage
      },
      {
        path: "/projects",
        name: "projects",
        component: Projects,
        meta: {
          title: "router.pages.project",
          icon: "projectsc",
          access: ["user", "manager", "issuer"]
        }
      },
      {
        path: "capital-history/:id?",
        name: "capital history",
        props: true,
        component: CapitalHistory,
        meta: {
          title: "router.pages.investStory",
          parent: "projects"
        }
      },
      {
        path: "project-card-uikit/:id?",
        name: "project card uikit",
        props: true,
        component: ProjectPage,
        meta: {
          title: "router.pages.cardProject",
          parent: "projects"
        }
      },
      // {
      //   path: "project-card-rwa/:id?",
      //   name: "project card rwa",
      //   props: true,
      //   component: RwaProjectPage,
      //   meta: {
      //     title: "router.pages.cardProject",
      //     parent: "projects"
      //   }
      // },
      {
        path: "project-card/:id?",
        name: "project card",
        props: true,
        component: checkAccess(scope.notRwa) ? ProjectCard : ProjectCardRwa,
        meta: {
          title: "router.pages.cardProject",
          parent: "projects"
        },
        children: [
          {
            path: "vote-history/:id?",
            name: "vote history",
            props: true,
            component: CapitalHistory,
            meta: {
              title: "router.pages.investStoryVote",
              voting: true
            }
          },
          {
            path: "portfolio-explorer/:id?",
            name: "portfolio explorer",
            props: true,
            component: PortfolioExplorer,
            meta: {
              title: "router.pages.portfolioExplorer"
            }
          }
        ]
      },
      {
        path: "news/:id",
        name: "single news",
        props: true,
        component: SingleNews,
        meta: {
          title: "router.pages.newsOne",
          parent: "news"
        },
        children: [
          {
            path: "vote-history/:id?",
            name: "vote history for news",
            props: true,
            component: CapitalHistory,
            meta: {
              title: "router.pages.investStoryVote",
              voting: true
            }
          }
        ]
      },
      {
        path: "news-capital",
        name: "news capital",
        component: NewsCapital,
        meta: {
          title: "router.pages.news",
          icon: "newsc",
          access: ["user", "manager", "issuer"]
        }
      },
      {
        path: "investers",
        name: "investers",
        component: Investers,
        meta: {
          title: "router.pages.investors",
          icon: "trend_up",
          access: ["user", "manager", "issuer"]
        }
      },
      {
        path: "business",
        name: "business",
        component: Business,
        meta: {
          title: "router.pages.business",
          icon: "personal_card",
          access: ["user", "manager", "issuer"]
        }
      },
      {
        path: "top-votes/:category?",
        name: "top votes",
        props: true,
        component: TopVotes,
        meta: {
          title: "router.pages.topVotes"
        }
      },
      {
        path: "voting-history",
        name: "voting history",
        component: VotingHistory,
        meta: {
          title: "router.pages.votingHistory"
        }
      },
      {
        path: "referrals",
        name: "referrals",
        component: Referrals,
        meta: {
          title: "router.pages.referrals"
        }
      },
      {
        path: "my-platforms",
        name: "my platforms",
        component: MyPlatforms,
        meta: {
          title: "router.pages.myPlatforms",
          isMain: true
        },
        children: [
          {
            path: "api-doc",
            name: "api doc",
            component: Swagger,
            meta: {
              title: "router.pages.apiDoc"
            }
          },
          {
            path: "new-platform/:id?",
            name: "new platform",
            props: true,
            component: NewPlatform,
            meta: {
              title: "router.pages.newPlatform"
            }
          }
        ]
      }
    ]
  },
  {
    path: "/",
    name: "autentic market",
    component: AutenticMarket,
    meta: {
      title: "router.market",
      logo: "logo_market",
      isMain: true,
      auth: true
    },
    children: [
      {
        path: "",
        name: "autentic market empty",
        redirect: "/marketplace"
      },
      {
        path: "marketplace",
        name: "marketplace",
        component: Marketplace,
        meta: {
          title: "router.pages.marketplace",
          icon: "marketplace_green",
          access: ["user", "manager", "issuer"]
        }
      },
      {
        path: "marketplace-card/:id",
        name: "marketplace card",
        component: MarketplaceCard,
        meta: {
          title: "router.pages.product"
        }
      },
      {
        path: "multitoken-card/:id?",
        name: "multitoken card",
        component: MultitokenCard,
        props: true,
        meta: {
          title: "router.pages.crushedAsset"
        }
      },
      {
        path: "delivery",
        name: "delivery",
        meta: {
          title: "router.pages.delivery",
          icon: "delivery_green",
          access: ["user", "manager", "issuer"]
        }
      },
      {
        path: "payment",
        name: "payment",
        meta: {
          title: "router.pages.payment",
          icon: "payment_green",
          access: ["user", "manager", "issuer"]
        }
      },
      {
        path: "guarantees",
        name: "guarantees",
        meta: {
          title: "router.pages.guarantees",
          icon: "guarantees_green",
          access: ["user", "manager", "issuer"]
        }
      }
    ]
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: {
      title: "login"
    }
  },
  {
    path: "/oauth/google",
    children: [
      { path: "/oauth/fb", component: AuthSocial }
    ],
    name: "AuthSocial",
    component: AuthSocial,
    meta: {
      title: "AuthSocial"
    }
  },
  {
    path: "/email_verify/:hash",
    name: "EmailVerify",
    component: EmailVerify,
    meta: {
      title: "Verify"
    }
  },
  {
    path: "/sign",
    name: "sign",
    component: Login,
    meta: {
      title: "register"
    }
  },
  {
    path: "/emitent-signup",
    name: "emitent signup",
    component: Login,
    meta: {
      title: "register",
      emitent: true
    }
  },
  {
    path: "/logout",
    name: "logout",
    component: Logout
  },
  {
    path: "/password_restore/:hash?",
    name: "password restore",
    props: true,
    component: PasswordRestore
  },
  {
    path: "/privacy-policy",
    name: "privacy policy",
    component: PrivacyPolicy,
    meta: {
      outer: true
    }
  },
  {
    path: "/user-agreement",
    name: "user agreement",
    component: UserAgreement
  },
  {
    path: "/terms-of-use",
    name: "terms of use",
    component: TermsOfUse,
    meta: {
      outer: true
    }
  },
  {
    path: "/payment-terms",
    name: "payment terms",
    component: PaymentTerms
  },
  {
    path: "/risk-disclosure",
    name: "risk disclosure",
    component: RiskDisclosure,
    meta: {
      outer: true
    }
  },
  {
    path: "/complaints-procedure",
    name: "complaints procedure",
    component: ComplaintsProcedure,
    meta: {
      outer: true
    }
  },
  {
    path: "/cookie-policy",
    name: "cookie policy",
    component: CookiePolicy,
    meta: {
      outer: true
    }
  },
  {
    path: "/aml-policy",
    name: "aml policy",
    component: AmlPolicy,
    meta: {
      outer: true
    }
  },
  {
    path: "/:pathMatch(.*)*",
    name: "page not found",
    component: PageNotFound
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

import CookiePolicy from "@/pages/CookiePolicy.vue";
import ItParkEditPage from "@/components/uikit/platformPages/ItParkEditPage.vue";
import ItParkListPage from "@/components/uikit/platformPages/ItParkListPage.vue";
import ItParkShowPage from "@/components/uikit/platformPages/ItParkShowPage.vue";
import PaymentTerms from "@/pages/PaymentTerms.vue";
import ProjectCardRwa from "@/appPages/ProjectCardRwa.vue";
import RiskDisclosure from "@/pages/RiskDisclosure.vue";
// import RwaProjectPage from "@/components/uikit/platformPages/RwaProjectPage.vue";
import AmlPolicy from "@/pages/AmlPolicy.vue";
import ComplaintsProcedure from "@/pages/ComplaintsProcedure.vue";
import ProjectFormV2 from "@/appPages/ProjectFormV2.vue";
import ProjectVotersPage from "@/appPages/ProjectVotersPage.vue";
import store from "@/store/index.js";
import TopVotes from "@/appPages/TopVotes";
import VotingHistory from "@/appPages/VotingHistory";
import { checkAccess, scope } from "@/help/accessData";

router.beforeEach((to, from, next) => {
  if (to.name == "login"
    && to.redirectedFrom?.path
    && Object.keys(to.query).length == 0
    && to.redirectedFrom?.name != "dashboard") {
    next({ name: "login", query: { path: to.redirectedFrom.fullPath } });
  }

  if (to.meta.outer) {
    document.documentElement.style.setProperty("overflow", "hidden");
    store.dispatch("setIsLightTheme", true);
  }

  if (to.query.outer) {
    store.dispatch("setOuterPath", to.path);
  }

  if (to.meta.checkAccess) {
    if (to.meta.checkAccess() == false) {
      next({ path: "/" });
    }
  }

  next();
});

export default router;
